import { request } from "../utils/request.js"

export const enumByName = (name, args) => request({
    url: 'enum/' + name,
    method: 'GET',
    showFailMessage: true,
    ...args
})


export const enum_CustomerMedicalRecordTypeEnum = (args) => request({
    url: 'enum/CustomerMedicalRecordTypeEnum',
    method: "GET",
    showFailMessage: true,
    ...args
})

export const enum_SysMenuTypeEnum = (args) => request({
    url: 'enum/SysMenuTypeEnum',
    method: "GET",
    showFailMessage: true,
    ...args
})

export const enum_UserLoginSourceTypeEnum = (args) => request({
    url: 'enum/UserLoginSourceTypeEnum',
    method: "GET",
    showFailMessage: true,
    ...args
})

export const enum_UserTypeEnum = (args) => request({
    url: 'enum/UserTypeEnum',
    method: "GET",
    showFailMessage: true,
    ...args
})







// WEBPACK FOOTER //
// ./src/api/enum.js